// src/components/RichCaption.js
//
// Post/klip caption'larında @mention ve #hashtag linkleştirme.
// Token kuralları ProfileBio'daki P2-7 implementasyonuyla birebir aynı
// (boundary: satır başı veya alfanümerik-olmayan karakter; e-posta
// adresleri mention sayılmaz; hashtag Türkçe harf destekler).
//
// @username → /u/username (SPA-içi pushState)
// #etiket   → /explore?tag=etiket

import React from "react";

const TOKEN_REGEX = /(^|[^A-Za-z0-9_.])(@[A-Za-z0-9_.]{2,30}|#[\p{L}\p{N}_]{1,50})(?![\p{L}\p{N}])/gu;

function navigateInApp(path: string) {
  try {
    if (window.location.pathname + window.location.search !== path) {
      window.history.pushState({}, "", path);
    }
    window.dispatchEvent(new PopStateEvent("popstate"));
  } catch { /* no-op */ }
}

function CaptionToken({ token }: { token: string }) {
  const isMention = token.startsWith("@");
  const value = token.slice(1);
  const path = isMention
    ? `/${encodeURIComponent(value.toLowerCase())}`
    : `/explore/tags/${encodeURIComponent(value)}`; // IG biçimi (yol) + SEO; ?tag= geriye-uyumlu okunur
  return (
    <a
      className="rich-caption-token"
      href={path}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigateInApp(path);
      }}
    >
      {token}
    </a>
  );
}

/**
 * Caption metnini düz parçalar + tıklanabilir @mention/#hashtag
 * token'larına bölerek render eder.
 */
export default function RichCaption({ text }: { text?: string | null }) {
  const str = String(text || "");
  if (!str) return null;
  const out: React.ReactNode[] = [];
  let last = 0;
  let m;
  TOKEN_REGEX.lastIndex = 0;
  while ((m = TOKEN_REGEX.exec(str)) !== null) {
    const tokenStart = m.index + m[1].length;
    if (tokenStart > last) out.push(str.slice(last, tokenStart));
    out.push(<CaptionToken key={`t${tokenStart}`} token={m[2]} />);
    last = tokenStart + m[2].length;
  }
  if (last < str.length) out.push(str.slice(last));
  return <>{out}</>;
}
